var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Messages/mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.49996 4.16668L8.97673 9.20416C9.57858 9.67227 10.4213 9.67227 11.0232 9.20416L17.5 4.16668M4.33329 16.6667H15.6666C16.6 16.6667 17.0668 16.6667 17.4233 16.485C17.7369 16.3252 17.9918 16.0703 18.1516 15.7567C18.3333 15.4001 18.3333 14.9334 18.3333 14V6.00001C18.3333 5.06659 18.3333 4.59988 18.1516 4.24336C17.9918 3.92976 17.7369 3.67479 17.4233 3.515C17.0668 3.33334 16.6 3.33334 15.6666 3.33334H4.33329C3.39987 3.33334 2.93316 3.33334 2.57664 3.515C2.26304 3.67479 2.00807 3.92976 1.84828 4.24336C1.66663 4.59988 1.66663 5.06659 1.66663 6.00001V14C1.66663 14.9334 1.66663 15.4001 1.84828 15.7567C2.00807 16.0703 2.26304 16.3252 2.57664 16.485C2.93316 16.6667 3.39987 16.6667 4.33329 16.6667Z",
    stroke: "#858C95",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.d0f2a225b1df0abe32b3c6debb653e3b.svg";
export { ForwardRef as ReactComponent };